export default __webpack_public_path__ + "static/media/inzi.0b14a1ac.png";